import React, { useCallback, useMemo } from "react"
import useSWR from "swr"
import { some } from "lodash"

import { Genre } from "src/models/genre/Genre"
import { useLoading } from "src/components/hooks/useLoading"
import { fetchGenres } from "../../models/genre/fetchGenres"
import styles from "./GenreSelector.module.scss"

export type Props = {
  selected: Genre[]
  onSubmit: (genre: Genre[]) => void
  isShowCategoryTitle?: boolean
}

/** ジャンル選択 */
const GenreSelector: React.FC<Props> = ({ onSubmit, selected }) => {
  const { fullScreenLoading } = useLoading()
  const { data, error } = useSWR("/v1/genre", fetchGenres)

  if (error) {
    // eslint-disable-next-line no-console
    console.log(error)
    fullScreenLoading(false)
  }

  if (data) {
    fullScreenLoading(false)
  }

  const genres = useMemo(() => {
    return data || []
  }, [data])
  const isChecked = useCallback(
    (g: Genre) => {
      return some(selected, g)
    },
    [selected],
  )

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      try {
        const g = JSON.parse(e.target.value)
        let newSelected: Genre[] = [...selected]
        if (some(selected, g)) {
          newSelected = selected.filter((item) => item.id !== g.id)
        } else {
          if (selected.length >= 3) {
            alert("ジャンルは3つまで選択可能です。")

            return
          }
          newSelected.push(g)
        }
        onSubmit(newSelected)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    },
    [onSubmit, selected],
  )

  return genres ? (
    <ul className={styles.Genres}>
      {genres.map((genre) => (
        <li key={genre.id} className={styles.GenresItem}>
          <p className={styles.Checkbox}>
            <label className={styles.Checkbox_label}>
              <input
                className={styles.Checkbox_input}
                type="checkbox"
                checked={isChecked(genre)}
                value={JSON.stringify(genre)}
                onChange={handleChange}
              />
              {genre.name}
            </label>
          </p>
        </li>
      ))}
    </ul>
  ) : (
    <></>
  )
}

export default GenreSelector
